import CtaBlock from "./CtaBlock";

const CtaBlockWithProps = ({ blok }) => {
  return <CtaBlock title={blok.title} description={blok.description} ctas={blok.ctas} theme={blok.theme} />;
};

export default CtaBlockWithProps;
